module.exports = __webpack_public_path__ + "static/media/Birrete.a1bb1598.svg";